const getImageAdWithLogoPlacementBaseStyles = () => ({
  placementCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',

    position: 'relative',
    boxSizing: 'content-box',
    overflow: 'hidden',
    background: 'transparent',

    '& .placement-card-content': {
      width: '100%',
      height: '100%',
      padding: 8,
    },
  },
  placementImageContainer: {
    margin: '4px 8px 4px 8px',
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    margin: '4px 8px 4px 8px',
  },
  logoTextContainer: {
    marginLeft: 8,
  },
  placementShortHeadline: {
    color: '#1A0DAB',
    fontSize: 16,
    weight: 400,
    lineHeight: '19px',
    margin: '5px 0',
  },
  placementLongHeadline: {
    weight: 600,
    lineHeight: '24px',
    fontSize: 20,
    overflow: 'hidden',
    color: 'rgba(43, 43, 43, 1)',
    margin: '5px 0 15px 0',
  },
  displayUrlContainer: {
    lineHeight: '17px',
    fontWeight: 700,
    fontSize: 12,
    color: '#006621',
  },
  placementAdsLabel: {
    position: 'static !important',
    color: '#767676 !important',
    border: '1px solid #ddd !important',
    margin: '0 4px 0 0 !important',
    display: 'inline',
    opacity: '100% !important',
    padding: '0 2px !important',
    maxHeight: 16,
    fontWeight: 600,
    lineHeight: 1,
    borderRadius: '6px !important',
  },
  placementTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '4px 8px 4px 8px',
    fontSize: 10,
    lineHeight: '16px',
    color: '#0078d4',
    overflow: 'hidden',
    '&:hover': {
      color: '#004578',
    },
  },
  priceText: {
    color: '#000000',
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 400,
    margin: '5px 0 10px 0',
  },
  placementDescription: {
    color: '#666666',
    display: 'inline-block',
    fontSize: 12,
    lineHeight: '17px',
    fontWeight: 400,
    flexGrow: 1,
    overflow: 'hidden',
    margin: '5px 0 10px 0',
  },
  placementCallToAction: {
    border: '1px solid #106EBE',
    background: '#106EBE',
    width: 181,
    height: 30,
    borderRadius: 6,
    padding: '5px, 15px, 5px, 15px',
    fontSize: 13,
    fontWeight: 400,
    lineHeight: '21px',
    color: '#FFFFFF',
  },
});

export const getImageAdWithLogoPlacementStyles = (theme) => {
  const {
    placementCard,
    placementImageContainer,
    ...baseStyles
  } = getImageAdWithLogoPlacementBaseStyles(theme);
  const styles = {
    ...baseStyles,
    placementCard: {
      ...placementCard,
      '& .placement-card-content': {
        width: 339,
        padding: 8,
      },
    },
    placementImageContainer: {
      display: 'none',
    },
  };
  return styles;
};

export const getImageAdWithLogoPlacementWithImageStyles = (theme) => {
  const {
    placementShortHeadline,
    placementCallToAction,
    ...baseStyles
  } = getImageAdWithLogoPlacementBaseStyles(theme);
  const styles = {
    ...baseStyles,
    placementShortHeadline: {
      ...placementShortHeadline,
      color: '#242424',
      fontSize: 12,
      weight: 600,
      lineHeight: '16px',
      margin: '5px 0',
    },
    placementCallToAction: {
      ...placementCallToAction,
      border: '1px solid #DDDDDD',
      background: '#F5F5F5',
      width: 92,
      height: 28,
      borderRadius: 16,
      padding: '0px, 15px, 0px, 15px',
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '22px',
      color: '#666666',
    },
    adInfoLabel: {
      color: '#00AECD',
      position: 'absolute',
      right: '10%',
      top: '90%',
    },
  };
  return styles;
};
